const initialState = {
  videos: [],
  searchQuery: '',
}

const videoReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_VIDEOS':
      return {
        ...state,
        videos: action.payload,
      }
    case 'CLEAR_VIDEOS':
      return {
        ...state,
        videos: [],
      }
    case 'SET_SEARCH_QUERY':
      return {
        ...state,
        searchQuery: action.payload,
      }
    default:
      return state
  }
}

export default videoReducer
